import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { demoIssueStatus, demoModeEnabled, demoStartFlow, demoVerifyStatus } from './demoMode';

// Integrated Test Bed endpoints. The dev proxy adds the x-tenant-key header.

// The France Identité gateway WAF rejects any query parameter named `sessionId`.
// That build sets REACT_APP_SESSION_PARAM=sid; the nginx in our image translates it
// back before proxying, so the backend keeps its own parameter name.
const sessionParam = process.env.REACT_APP_SESSION_PARAM || 'sessionId';

export const startIssuance = createAsyncThunk(
        'playground/startIssuance', ({sessionId, credentialType}: {sessionId: string, credentialType: string}) => {
            if (demoModeEnabled()) {
                return Promise.resolve(demoStartFlow(sessionId));
            }
            return axios.get('/public/itb/credentialIssuanceRequest', {params: {[sessionParam]: sessionId, credentialType}})
                    .then(response => response.data);
        },
);

export const fetchIssueStatus = createAsyncThunk(
        'playground/fetchIssueStatus', ({sessionId}: {sessionId: string}) => {
            if (demoModeEnabled()) {
                return Promise.resolve(demoIssueStatus(sessionId));
            }
            return axios.get('/public/itb/issueStatus', {params: {[sessionParam]: sessionId}})
                    .then(response => response.data);
        },
);

export const startVerification = createAsyncThunk(
        'playground/startVerification', ({sessionId, queryId}: {sessionId: string, queryId: string}) => {
            if (demoModeEnabled()) {
                return Promise.resolve(demoStartFlow(sessionId));
            }
            return axios.get('/public/itb/presentationVerificationRequest', {params: {[sessionParam]: sessionId, queryId}})
                    .then(response => response.data);
        },
);

// The queryId travels along: a session lives in the wallet that created it, and the
// age-verification templates are answered by a different wallet than the rest.
export const fetchVerifyStatus = createAsyncThunk(
        'playground/fetchVerifyStatus', ({sessionId, queryId}: {sessionId: string, queryId: string}) => {
            if (demoModeEnabled()) {
                return Promise.resolve(demoVerifyStatus(sessionId));
            }
            return axios.get('/public/itb/verifyStatus', {params: {[sessionParam]: sessionId, queryId}})
                    .then(response => response.data);
        },
);
